import { type RefObject } from 'react';

export type AxiDarkModeToggleProps = {
  /** Whether the settings panel is currently open. Mirrored to aria-expanded. */
  open: boolean;
  /** Toggle handler. Receives no arguments. */
  onToggle: () => void;
  /**
   * Optional ref to the trigger button. Wired so the settings panel can
   * restore focus to this element when it closes. Accepts the standard
   * `useRef` ref shape (which is internally `RefObject<T | null>`).
   */
  buttonRef?: RefObject<HTMLButtonElement | null>;
};

/**
 * Gear icon button rendered in the Topbar's extra slot. Clicking it opens
 * (or closes) the settings drawer. The icon is an inline SVG (no font /
 * asset dependency).
 */
function AxiDarkModeToggle({ open, onToggle, buttonRef }: AxiDarkModeToggleProps) {
  return (
    <button
      ref={buttonRef}
      type="button"
      className="axi-dark-mode-toggle"
      aria-label="切换主题"
      aria-expanded={open}
      aria-controls="axi-settings-panel"
      onClick={onToggle}
    >
      <svg
        viewBox="0 0 24 24"
        width="18"
        height="18"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <circle cx="12" cy="12" r="3" />
        <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09a1.65 1.65 0 0 0-1-1.51 1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09a1.65 1.65 0 0 0 1.51-1 1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
      </svg>
    </button>
  );
}

export default AxiDarkModeToggle;